import { TransitionColors } from '@grandvisionhq/lib-lime';
import { useFeatureToggles, useSelector } from '@grandvisionhq/state';
import '../state/actions.js';
import '../state/add-to-cart/selectors.js';
import '../state/bundles/selectors.js';
import '../state/bundles/reducer.js';
import { getSelectedAddOn } from '../state/configurator/selectors.js';
import '../state/configurator/reducer.js';
import '../state/products/selectors.js';
import '../state/products/reducer.js';

const LowerCasedTransitionColors = TransitionColors.map((s)=>s.toLowerCase()
);
function useTransitionColor() {
    const { isLimeEnabled  } = useFeatureToggles();
    const selectedAddOn = useSelector(getSelectedAddOn);
    if (!isLimeEnabled || !(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.colorCode)) {
        return null;
    }
    const index = LowerCasedTransitionColors.indexOf(selectedAddOn.colorCode.toLowerCase());
    if (!TransitionColors[index]) {
        return null;
    }
    return index >= 0 ? TransitionColors[index] : null;
}

export { useTransitionColor };
//# sourceMappingURL=use-transition-color.js.map
